// Streams TTS audio bytes from /api/speak-stream. Pure transport layer
// — no AudioContext, no decode, no playback. Callers feed the returned
// ReadableStream into TTSPlayer (or read it directly for diagnostics).

const ENDPOINT = '/api/speak-stream';
const RETRY_BACKOFF_MS = 1000;

export default class TTSSource {
  async stream(text, voiceId, options = {}) {
    const { signal } = options;
    const body = JSON.stringify({ text, voiceId });

    let response;
    try {
      response = await this._fetchOnce(body, signal);
    } catch (err) {
      if (signal && signal.aborted) throw err;
      await new Promise((r) => setTimeout(r, RETRY_BACKOFF_MS));
      if (signal && signal.aborted) {
        throw new DOMException('Aborted', 'AbortError');
      }
      response = await this._fetchOnce(body, signal);
    }

    if (!response.ok) {
      const snippet = await response
        .text()
        .then((t) => t.slice(0, 200))
        .catch(() => '');
      throw new Error(
        `TTSSource: /api/speak-stream returned ${response.status}: ${snippet}`
      );
    }
    if (!response.body) {
      throw new Error('TTSSource: response has no body stream');
    }
    return response.body;
  }

  async _fetchOnce(body, signal) {
    return fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      signal,
    });
  }
}
